import { Checkbox, withStyles } from '@material-ui/core';
import React from 'react';
import {
  CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon,
  CheckBox as CheckBoxIcon
} from '@material-ui/icons';

const styles = (theme) => ({
  root: {
    padding: 0,
    verticalAlign: 'middle',
    height: '100%',
    color: theme.gridIconBorderColor,
    '&$checked': {
      color: theme.HeaderSelectedText
    }
  },
  checked: {
    color: theme.HeaderSelectedText
  }
});

const CheckboxRenderer = ({ classes, ...params }) => {
  const { value, onChange } = params;

  const handleChange = (event, checked) => {
    onChange(checked); // Call function with row data
  };

  return (
    <Checkbox
      checked={value}
      onChange={handleChange}
      icon={<CheckBoxOutlineBlankIcon />}
      checkedIcon={<CheckBoxIcon />}
      classes={{
        root: classes.root,
        checked: classes.checked
      }}
    />
  );
};

export default withStyles(styles)(CheckboxRenderer);
